import { makeAppKey } from '@atlassian/mpac-api-client';
import { makeInstalledAppFromSPIInstalledApp } from '@atlassian/mpac-spi';
import { AppDeployment } from '@atlassian/mpac-types';
import { MarketplaceAppPaymentModel } from '@atlassian/mpac-types/graphql-gateway-types';
import { makeInstallableAppByAriIdentifier, makeInstallableAppByKeyIdentifier, toSPIInstallableAddonIdentifier } from '../../../../records/InstallableAppIdentifier';
import getSPI from '../../../../services/SPI';
import { reflect } from '../../../../utils/promise-utils';
const makeCloudMigrationTrialFromNonInstallableApp = upmAvailableApp => {
  return {
    isEligible: Boolean(upmAvailableApp.cmtEligible),
    btfSenEndDate: upmAvailableApp.btfSenEndDate ? new Date(upmAvailableApp.btfSenEndDate) : undefined
  };
};

// TODO add types
const getInstallableIdentifier = (appKey, deploymentType, marketplaceApp) => {
  if (marketplaceApp !== null && marketplaceApp !== void 0 && marketplaceApp.cloudAppVersions && deploymentType === AppDeployment.ECOSYSTEM_CLOUD) {
    var _marketplaceApp$cloud, _marketplaceApp$cloud2, _marketplaceApp$cloud3;
    const appDeployment = (_marketplaceApp$cloud = marketplaceApp.cloudAppVersions.edges) === null || _marketplaceApp$cloud === void 0 ? void 0 : (_marketplaceApp$cloud2 = _marketplaceApp$cloud[0]) === null || _marketplaceApp$cloud2 === void 0 ? void 0 : (_marketplaceApp$cloud3 = _marketplaceApp$cloud2.node) === null || _marketplaceApp$cloud3 === void 0 ? void 0 : _marketplaceApp$cloud3.deployment;
    const ari = appDeployment === null || appDeployment === void 0 ? void 0 : appDeployment.cloudAppId;
    return makeInstallableAppByAriIdentifier({
      ari: makeAppKey(ari),
      appKey: makeAppKey(appKey || '')
    });
  } else {
    return makeInstallableAppByKeyIdentifier({
      key: makeAppKey(appKey)
    });
  }
};
export async function fetchMarketplaceAppData(_ref) {
  let {
    appKey,
    fetchInstalledApp,
    contextId,
    deploymentType,
    marketplaceApp,
    flags,
    hostCmtEnabled
  } = _ref;
  const installableAddonPromise = getSPI().getInstallableAddon({
    addon: toSPIInstallableAddonIdentifier(getInstallableIdentifier(appKey, deploymentType, marketplaceApp)),
    hostCmtEnabled
  });
  const permissionCheckPromise = () => reflect(installableAddonPromise.then(ia => getSPI().hasInstallPermission({
    addon: ia
  })));
  const installedAppPromise = () => getSPI().getInstalledAddon({
    contextId,
    addon: toSPIInstallableAddonIdentifier(getInstallableIdentifier(appKey, deploymentType, marketplaceApp)),
    flags
  }).then(installedAddonResult => {
    return installedAddonResult.status === 'NOT_FOUND' ? null : installedAddonResult;
  })
  // eslint-disable-next-line promise/no-return-wrap
  .catch(() => Promise.resolve(null));
  const sandboxEligibilityPromise = installableAddonPromise.then(installableAddon => installableAddon.eligibleForFreeOnSandbox).catch(() => false);
  const cloudMigrationTrialPromise = installableAddonPromise.then(installableAddon => installableAddon.cloudMigrationTrial)
  // Incase app is non-installable but still eligible for cloudMigrationTrial
  .catch(function () {
    let {
      upmAvailableApp
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (upmAvailableApp) return makeCloudMigrationTrialFromNonInstallableApp(upmAvailableApp);
    return {
      isEligible: false
    };
  });
  const parentCapabilitySetPromise = installableAddonPromise.then(installableAddon => installableAddon.parentCapabilitySet).catch(() => {
    return null;
  });
  const [eligibleForFreeOnSandbox, installPermission, installedAddon, cloudMigrationTrial, parentCapabilitySet] = await Promise.all([sandboxEligibilityPromise, permissionCheckPromise(), fetchInstalledApp ? installedAppPromise() : null, cloudMigrationTrialPromise, parentCapabilitySetPromise]);
  return {
    installedApp: installedAddon ? makeInstalledAppFromSPIInstalledApp(installedAddon) : undefined,
    installPermission,
    eligibleForFreeOnSandbox,
    cloudMigrationTrial,
    parentCapabilitySet
  };
}
export const getAppDeploymentType = appListing => {
  var _appListing$cloudAppV, _appListing$cloudAppV2;
  const appVersion = (_appListing$cloudAppV = appListing.cloudAppVersions.edges) === null || _appListing$cloudAppV === void 0 ? void 0 : (_appListing$cloudAppV2 = _appListing$cloudAppV[0]) === null || _appListing$cloudAppV2 === void 0 ? void 0 : _appListing$cloudAppV2.node;
  return appVersion === null || appVersion === void 0 ? void 0 : appVersion.deployment.__typename;
};
export const getInstallableAddon = (appDeployment, appKey) => {
  if (appDeployment !== null && appDeployment !== void 0 && appDeployment.cloudAppId) {
    return makeInstallableAppByAriIdentifier({
      ari: makeAppKey(appDeployment.cloudAppId || ''),
      appKey: makeAppKey(appKey || '')
    });
  } else {
    return makeInstallableAppByKeyIdentifier({
      key: makeAppKey(appKey || '')
    });
  }
};
export const AppListingPaymentModel = {
  [MarketplaceAppPaymentModel.Free]: 'free',
  [MarketplaceAppPaymentModel.PaidViaAtlassian]: 'atlassian',
  [MarketplaceAppPaymentModel.PaidViaPartner]: 'vendor'
};
export const mapAppListingPaymentModel = paymentModel => paymentModel ? AppListingPaymentModel[paymentModel] : undefined;